import { useQuery } from '@tanstack/react-query'
import * as React from 'react'

import { apiRequest } from '../../../services/api'

const NEWS_REFRESH_INTERVAL = 60 * 1000 // 1 minute
const NEWS_STALE_TIME = 1000 * 20 // 20 seconds

interface QuoteNewsResponse {
  html: string
  timestamp: string
}

interface UseNewsRefreshOptions {
  ticker: string
}

function quoteNewsRequest(ticker: string) {
  return apiRequest<QuoteNewsResponse>(`/api/quote-news/${ticker}`, undefined, true)
}

export function useNewsRefresh({ ticker }: UseNewsRefreshOptions) {
  const { data } = useQuery({
    queryKey: ['quoteNews', ticker],
    queryFn: () => quoteNewsRequest(ticker),
    refetchInterval: NEWS_REFRESH_INTERVAL,
    refetchIntervalInBackground: false,
    staleTime: NEWS_STALE_TIME,
    initialData: null,
  })

  // Update the DOM when data changes
  React.useEffect(() => {
    if (!data?.html || !ticker) return

    const newsTable = document.querySelector<HTMLTableElement>(`#news-table[data-ticker="${ticker}"]`)
    if (newsTable && newsTable.innerHTML !== data.html) {
      newsTable.innerHTML = data.html
    }
  }, [data, ticker])

  return null
}
